import React from "react";
import { HeroSlideshowComponentEditor } from "cms/components/components/hero-slideshow/edit";
import { HeroSlideshowComponentDisplay } from "cms/components/components/hero-slideshow/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const HeroSlideshowComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <HeroSlideshowComponentDisplay />,
        editComponent: <HeroSlideshowComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

HeroSlideshowComponent.displayName = "HeroSlideshowComponent";
export { HeroSlideshowComponent };
